import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Dropdown } from "qubCommon/Inputs";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

const CreateMhdDialog = ({
  open,
  title = "Δημιουργία ΜΗΔ",
  content = "Επιλέξτε ...",
  onClose = () => {},
  onConfirm = () => {},
  employees,
  prefectures,
}) => {
  const { id } = useParams();

  const {
    getValues,
    setError,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const handleClose = () => {
    onClose();
  };

  const handleConfirm = async () => {
    const { SupervisingEmployeeId, PrefectureOrgId } = getValues();

    let hasError = false;

    if (!SupervisingEmployeeId) {
      setError("SupervisingEmployeeId", {
        type: "manual",
        message: "Απαιτείται επιλογή",
      });
      hasError = true;
    } else {
      clearErrors("SupervisingEmployeeId");
    }

    if (!PrefectureOrgId) {
      setError("PrefectureOrgId", {
        type: "manual",
        message: "Απαιτείται επιλογή",
      });
      hasError = true;
    } else {
      clearErrors("PrefectureOrgId");
    }

    if (!hasError) {
      await onConfirm(); // or pass values if needed
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h6">{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={2}>
          <Dropdown
            label="Συντονιστής"
            name="SupervisingEmployeeId"
            options={employees || []}
            error={!!errors.SupervisingEmployeeId}
            helperText={errors.SupervisingEmployeeId?.message}
          />
          <Dropdown
            label="Εποπτεύων Φορέας"
            name="PrefectureOrgId"
            options={prefectures || []}
            error={!!errors.PrefectureOrgId}
            helperText={errors.PrefectureOrgId?.message}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="error" variant="contained">
          Έξοδος
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Δημιουργία
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateMhdDialog;
